module.exports = __webpack_public_path__ + "img/illust_number01.13fe0df.svg";